export default __webpack_public_path__ + "static/media/percentage-icon-purple.ecf4aa30.svg";